import React from 'react';
import $ from "jquery";
import axios from "axios";
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Menu,
    MenuItem
} from "@material-ui/core";
import SideBar from "./SideBar";
import Data from "./Data";
import Classes from "./Classes";
import "jquery/dist/jquery";
import "bootstrap/dist/js/bootstrap";
import { Input, Loading, Radio, Spacer, Button } from '@nextui-org/react';
import RegisterClassList from './RegisterClassList';
import InfiniteScroll from 'react-infinite-scroller';
import { useState } from 'react';
import { useEffect } from 'react';
import { BiSearchAlt } from 'react-icons/bi';
import { HiArrowLeft } from 'react-icons/hi';
import { NavLink } from 'react-router-dom';


function RegisterClass (props) {

    const [articles,setArticles] = useState([]);
    const [nextPage,setNextPage] = useState(0);
    const [hasMore,setHasMore] = useState(true);
    const [lengthh,setLengthh] = useState(0);
    const [search,setSearch] = useState("");

    const [day,setDay] = useState("شنبه");
    const [dayid,setDayid] = useState(0);
    
    let loader = null;
    const setMyLoader = element => {
        loader = element;
    };
    let myRef = null;
    const setMyRef = element => {
        myRef = element;
    };
    
    useEffect(() => {
        setHasMore(lengthh - articles.length > 0);
        if (articles.length >= parseInt(lengthh) && articles.length !== 0){
            $('#loading').addClass("invisible");
        } else {
            $('#loading').removeClass("invisible");
        }
    },[articles]);
    useEffect(() => {

        setLengthh(0);
        setNextPage(0);
        setArticles([]);
        setHasMore(true);
        
    },[dayid]);

    useEffect(() => {
        document.title =  "ثبت نام هنرجو - پنل مدیریت";

    }, []);

    const handleLoadMore=()=>{
        
        let token = localStorage.getItem('token');
        let data = new FormData();
        let st = " id != ''";
        data.append('token', token);
        data.append('how', '10');
        data.append('count', nextPage);
        data.append('if', st);
        data.append('dayid', dayid);
        data.append('search', search);
        setHasMore(false);
        
        axios.post(Data.mainserver+`/getClasses5.php`,data)
            .then(response => {
                $('#waitspinner').modal('hide');
                $('#progressTop').addClass('invisible');
                if (response.data.hasOwnProperty('data') &&
                    response.data.hasOwnProperty('length') &&
                    response.data.hasOwnProperty('row')) {
                        
                    $('#masters').removeClass('invisible');
                    
                    const lengthhh = response.data.length;
                    const {row , data} = response.data;
                    setLengthh(lengthhh);
                    setNextPage(row);
                    setArticles([...articles, ...data]);
                    

                }
                if (response.data.hasOwnProperty('no_item')){
                    $('#no_item').removeClass('invisible');
                }
                $('#select_instrument').removeClass('invisible');
                $('#loading').addClass('invisible');
            })
            .catch(error => {
                console.log(error)
            });

    }
    const handleSearch=(e)=>{

        if(e.preventDefault() != undefined){
            e.preventDefault();
        }
        
        setLengthh(0);
        setNextPage(0);
        setArticles([]);
        setHasMore(true);
        
    }

        return (
            <div className="container-fluid">
                
                <SideBar li="studentspanel" title="ثبت نام هنرجو" />
                <div className="bg-light p-4 homee" id="students" data-spy="scroll" data-target="navbar">

                <div className="d-flex justify-content-between align-items-center flex-md-nowrap border-bottom pb-4">
                    <h3 className="h5 text-center">{lengthh+" کلاس"}</h3>

                    <form onSubmit={handleSearch.bind(this)} className="input-group justify-content-center">
                        <Input
                            clearable
                            bordered
                            type="text"
                            name="search"
                            value={search}
                            className='m-2'
                            color='secondary'
                            placeholder="جست و جو ..."
                            helperText={"نام استاد یا نام کلاس"}
                            contentRight={<div className='circle-background' onClick={handleSearch.bind(this)}>
                                <BiSearchAlt />
                            </div>}
                            contentClickable={true}
                            onChange={(e) => setSearch(e.target.value)}
                            size='lg'
                        />
                        <Spacer y={1}/>
                        
                    </form>
                    <NavLink to="/students">
                    <Button
                        auto
                        light
                        css={{fontSize: '18px'}}
                        iconRight={<HiArrowLeft className='mr-2' fill="currentColor" />}
                        className='mr-2'>
                        <NavLink style={{color: 'currentcolor'}} to="/students">
                            بازگشت
                        </NavLink>
                    </Button>
                    </NavLink>
                </div>
                <Radio.Group css={{alignItems:'center', marginTop:'40px'}}
                    orientation="horizontal"
                    defaultValue={dayid} 
                    onChange={setDayid}>
                    <Radio value={0} color="secondary" size="lg">
                        {"شنبه"}
                    </Radio>
                    <Radio value={1} color="secondary" size="lg">
                        {"یک شنبه"}
                    </Radio>
                    <Radio value={2} color="secondary" size="lg">
                        {"دوشنبه"}
                    </Radio>
                    <Radio value={3} color="secondary" size="lg">
                        {"سه شنبه"}
                    </Radio>
                    <Radio value={4} color="secondary" size="lg">
                        {"چهارشنبه"}
                    </Radio>
                    <Radio value={5} color="secondary" size="lg">
                        {"پنج شنبه"}
                    </Radio>
                </Radio.Group>
                <InfiniteScroll
                        element="div"
                        className="row mt-4"
                        ref={setMyLoader}
                        hasMore={hasMore}
                        loadMore={handleLoadMore.bind(this)}
                        getScrollParent={() => myRef}
                    >

                    {articles.map((products, index) => <RegisterClassList data={products} index={index}/>)}

                </InfiniteScroll>
                <div id="loading" className="mr-auto ml-auto mt-2 text-muted text-center">
                    <Loading color="secondary" size='xl'>در حال بارگزاری ...</Loading>
                </div>

            </div>
            </div>
        );
    

}


export default RegisterClass;